import { NodeRequestHandler } from '../../utils/http_request_handler/request_handler.node';
import { DefaultEventDispatcher } from './default_dispatcher';
const eventDispatcher = new DefaultEventDispatcher(new NodeRequestHandler());
export default eventDispatcher;
export const __platforms = ['node'];
//# sourceMappingURL=default_dispatcher.node.js.map